import * as React from 'react';
import { Button, Input, InputGroup, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { ConversionReportsClient } from '../../../../../client/ApiClient';
import { DataTableButton } from '../../../../basic/DataTable';
import { saveAs } from 'file-saver';
import Toolbar from "../../../../basic/Toolbar";

export interface StageToolbarProps {
    conversionId: string
    handleSearch?: (filter: string) => void
    sectionId?: string;
    mapExcel?: boolean;
    filter: string;
    children?: React.ReactNode;
    filterColumns?: string[];
    filteredColumn?: string;
    selectFilteredColumn?: (filteredColumn: string) => void
}

interface StageToolbarState {
    filteredColumnDisplay: string;
}

export default class StageToolbar extends React.Component<StageToolbarProps, StageToolbarState>{

    private report: ConversionReportsClient = new ConversionReportsClient();

    constructor(props: StageToolbarProps) {
        super(props)
        this.state = {
            filteredColumnDisplay:'',
        }
    }

    componentDidUpdate(prevProps: StageToolbarProps) {
        if (prevProps.filteredColumn !== this.props.filteredColumn && this.props.filteredColumn === '') {
            this.setState({ filteredColumnDisplay : ''})
        }
    }


    handleSearch = (e: any) => {
        let filter = e.target.value
        if (this.props.handleSearch) {
            this.props.handleSearch(filter)
        }
    }

    clearFilter = () => {
        if (this.props.handleSearch) {
            this.props.handleSearch('')
        }
    }

    handleSearchInput = (event: { keyCode: any; which: any; preventDefault: () => void; }) => {
        const keyCode = event.keyCode || event.which

        // 37 is '%' symbol
        if (keyCode === 37) {
            event.preventDefault()
        }
    }

    private canHandleSearch = () => !!this.props.handleSearch;

    exportToExcel = (id: string) => {
        this.report.exportToExcel(this.props.conversionId, id, null, null)
            .then(response => saveAs(response!.data, response!.fileName))
            .catch(error => { });
    }

    selectFilteredColumn = (e: any) => {
        let filteredColumn = e.target.value

        if (filteredColumn === '') {
            this.clearFilter();
        }

        if (this.props.selectFilteredColumn) {
            this.props.selectFilteredColumn(filteredColumn)
        }

        let filteredColumnDisplay = filteredColumn.replace(/([A-Z]+)/g, ' $1')
        filteredColumnDisplay = String(filteredColumnDisplay).charAt(0).toUpperCase() + String(filteredColumnDisplay).slice(1)
        filteredColumnDisplay = filteredColumnDisplay.replace('Naic', 'NAIC')
        this.setState({ filteredColumnDisplay })
    }

    public render() {
        const sectionMap = this.props.sectionId;
        return (
            <Toolbar>
                <InputGroup>
                    {this.canHandleSearch() &&
                        <React.Fragment>
                            {this.props.filterColumns && <UncontrolledDropdown>
                                <DropdownToggle nav caret></DropdownToggle>
                                <DropdownMenu right>
                                    {this.props.filterColumns!.map(f => {
                                        let filter = f.replace(/([A-Z]+)/g, ' $1').replace('Naic', 'NAIC').replace('naic', 'NAIC').replace('pre Effective', 'Pre-Effective').replace('category Desc', 'Category')
                                        return <DropdownItem onClick={this.selectFilteredColumn} value={f}>{String(filter).charAt(0).toUpperCase() + String(filter).slice(1)}</DropdownItem>
                                    })}
                                    <DropdownItem divider />
                                    <DropdownItem onClick={this.selectFilteredColumn}>Reset</DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>}
                            <Input placeholder={'Search ' + this.state.filteredColumnDisplay}
                                name='filter'
                                onChange={this.handleSearch}
                                value={this.props.filter}
                            />
                            <InputGroup addonType='append' className='material-icon'>
                                <Button onClick={this.clearFilter}> close</Button>
                            </InputGroup>
                            {this.props.mapExcel ? < DataTableButton icon='file_download' id={sectionMap + "Map"} title='Export to Excel'
                                action={() => this.exportToExcel(`${sectionMap}Map`)} /> : null}
                        </React.Fragment>}
                </InputGroup>
                {this.props.children}
            </Toolbar>
        )
    }
}